<ng-container [formGroup]="formGroup">
  <app-pl-input-wrapper
    [id]="id"
    [label]="label | translate"
    inputType="custom"
    [formControlName]="'internal'"
    [hint]="hint"
    [hintType]="hintType"
    [fieldConfig]="fieldConfig"
  >
    <div class="pl-combobox-wrapper pl-input-border">
      <kendo-combobox
        #comboboxref
        [data]="filteredData | async"
        [readonly]="readonly"
        [loading]="isLoading"
        [valueField]="'id'"
        [textField]="'label'"
        [filterable]="true"
        [size]="size"
        [allowCustom]="allowCustom"
        [clearButton]="clearButton"
        [valueNormalizer]="valueNormalizer"
        [formControlName]="'internal'"
        [popupSettings]="{ popupClass: 'popup' }"
        (blur)="onBlur()"
        (open)="onOpen($event)"
      >
        <ng-container
          *ngIf="showCacheRefreshButton || !pageInfo?.allDataLoaded"
        >
          <ng-template
            *ngIf="pageInfoPosition === 'header'"
            kendoComboBoxHeaderTemplate
            let-dataItem
          >
            <pl-dropdown-page-info
              *ngIf="pageInfo || showCacheRefreshButton"
              [showCacheRefreshButton]="showCacheRefreshButton"
              [showPageButtons]="showPageButtons"
              [pageInfo]="pageInfo"
              (refreshCache)="refreshCache()"
              (pageInfoChange)="updatePageInfo($event)"
            ></pl-dropdown-page-info>
          </ng-template>
          <ng-template
            *ngIf="pageInfoPosition === 'footer'"
            kendoDropDownTreeFooterTemplate
            let-dataItem
          >
            <pl-dropdown-page-info
              *ngIf="pageInfo || showCacheRefreshButton"
              [showCacheRefreshButton]="showCacheRefreshButton"
              [showPageButtons]="showPageButtons"
              [pageInfo]="pageInfo"
              (refreshCache)="refreshCache()"
              (pageInfoChange)="updatePageInfo($event)"
            ></pl-dropdown-page-info>
          </ng-template>
        </ng-container>

        <ng-template *ngIf="allowCustom" kendoComboBoxNoDataTemplate>
          <h4>
            No data found.
            <br />Tab outside or press Enter to add custom item.
          </h4>
        </ng-template>
        <ng-template kendoComboBoxItemTemplate let-dataItem>
          <div class="content">
            <img *ngIf="displayImage && dataItem.image" [src]="dataItem.image" width="40" height="40" alt="">
            <span
              *ngIf="!displayImage && dataItem.icon"
              class="icon k-icon {{ dataItem.icon }}"
            ></span>
            <div class="title">
              <span>{{ dataItem.label }}</span>
              <div
                class="subTitle"
                [class.selected]="
                  !arrRef.isArray(value) && value && dataItem.id === value.id
                "
              >
                {{ dataItem.subLabel }}
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-combobox>
      <ng-container *ngIf="link">
        <kendo-textbox-separator></kendo-textbox-separator>
        <app-pl-input-anchor-suffix
          [fieldConfig]="fieldConfig"
          [value]="convertFromDropDownItemToValue(value)"
        ></app-pl-input-anchor-suffix>
      </ng-container>
    </div>
  </app-pl-input-wrapper>
</ng-container>
